module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userSchoolsSorted.length > 1) ? _c('div', {
    staticClass: "school-selector text-dark"
  }, [_c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn do-bttn--with-icon"
        }, [_vm._v("\n        " + _vm._s(_vm.selectedTitle) + "\n        "), _c('svg', {
          staticClass: "tw-icon tw-icon-cheveron-selection",
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          staticClass: "secondary",
          attrs: {
            "fill-rule": "evenodd",
            "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
          }
        })])])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', {
          staticClass: "school-selector__list text-dark",
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, _vm._l((_vm.userSchoolsSorted), function(school) {
          return _c('li', {
            key: school.id,
            staticClass: "school-selector__list__item",
            class: {
              'school-selector__list__item--disabled': school.v_has_permission
            },
            on: {
              "click": function($event) {
                return _vm.toggleSchool(school)
              }
            }
          }, [_vm._v("\n          " + _vm._s(school.name) + "\n          "), (school.v_is_selected) ? _c('svg', {
            staticClass: "tw-icon icon-check",
            attrs: {
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 24 24"
            }
          }, [_c('circle', {
            staticClass: "primary",
            attrs: {
              "cx": "12",
              "cy": "12",
              "r": "10"
            }
          }), _vm._v(" "), _c('path', {
            staticClass: "secondary",
            attrs: {
              "d": "M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"
            }
          })]) : _vm._e()])
        }), 0)]
      },
      proxy: true
    }], null, false, 1138270715)
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-667a63b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SchoolsSelector.vue
// module id = 1969
// module chunks = 1